import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class AppUrl {
  static get ADMIN_URL(): string {
    return environment.appUrl + 'admin/';
  }

  static get LOGIN(): string {
    return AppUrl.ADMIN_URL + 'login';
  }

  static get SELF(): string {
    return AppUrl.ADMIN_URL + 'self';
  }

  static UPDATE_PASSWORD(): string {
    return AppUrl.ADMIN_URL + 'update-password';
  }

  static UPDATE_SELF(): string {
    return AppUrl.ADMIN_URL + 'update-self';
  }

  static LOGOUT(): string {
    return AppUrl.ADMIN_URL + 'logout';
  }

  static UPDATE_PROFILE_IMAGE(): string {
    return AppUrl.ADMIN_URL + 'profile-image';
  }

  static FILE_UPLOAD(): string {
    return AppUrl.ADMIN_URL + 'file-upload';
  }

  static SINGLE_FILE_UPLOAD(): string {
    return AppUrl.ADMIN_URL + 'file-single-upload';
  }

  static MULTIPLE_FILE_UPLOAD(): string {
    return AppUrl.ADMIN_URL + 'file-multiple-upload';
  }

  static COUNTRY(): string {
    return AppUrl.ADMIN_URL + 'countries';
  }

  static USERS(): string {
    return AppUrl.ADMIN_URL + 'user';
  }

  static STATES(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'states/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'states';
  }

  static ADMIN(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'admin/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'admin';
    }
  }

  static ADMIN_COUNT(): string {
    return AppUrl.ADMIN_URL + 'admin-count';
  }

  static ADMIN_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'admin-status/' + unique_id;
  }

  static ADMIN_CHANGE_PASSWORD(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'admin-password/' + unique_id;
  }

  static AGENT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'agent/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'agent';
    }
  }

  static AGENT_COUNT(): string {
    return AppUrl.ADMIN_URL + 'agent-count';
  }

  static AGENT_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'agent-status/' + unique_id;
  }

  static AGENT_CHANGE_PASSWORD(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'agent-password/' + unique_id;
  }

  static AUDITOR(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'auditor/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'auditor';
    }
  }

  static AUDITOR_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'auditor-status/' + unique_id;
  }

  static AUDITOR_CHANGE_PASSWORD(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'auditor-password/' + unique_id;
  }

  static STAGE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'stage/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'stage';
    }
  }

  static STAGE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'stage-count';
  }

  static STAGE_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'stage-status/' + unique_id;
  }
  static REASON(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'reason/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'reason';
    }
  }

  static REASON_COUNT(): string {
    return AppUrl.ADMIN_URL + 'reason-count';
  }

  static REASON_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'reason-status/' + unique_id;
  }

  static SMS_TEMPLATE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'sms-template/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'sms-template';
    }
  }

  static SMS_TEMPLATE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'sms-template-count';
  }

  static SMS_TEMPLATE_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'sms-template-status/' + unique_id;
  }

  static WHATSAPP_TEMPLATE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'whatsapp-template/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'whatsapp-template';
    }
  }

  static WHATSAPP_TEMPLATE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'whatsapp-template-count';
  }

  static WHATSAPP_TEMPLATE_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'whatsapp-template-status/' + unique_id;
  }

  static SOCIAL_MEDIA(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'social-media/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'social-media';
    }
  }

  static SOCIAL_MEDIA_CREDENTIAL(): string {
    return AppUrl.ADMIN_URL + 'social-media-credential';
  }

  static MANUAL_LEAD(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'manual-lead/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'manual-lead';
    }
  }

  static MANUAL_LEAD_COUNT(): string {
    return AppUrl.ADMIN_URL + 'manual-lead-count';
  }

  static MANUAL_LEAD_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'manual-lead-status/' + unique_id;
  }

  static MANUAL_LEAD_ASSIGN(): string {
    return AppUrl.ADMIN_URL + 'manual-lead-assign';
  }

  static MANUAL_LEAD_FOLLOW_UP(uniqueId): string {
    return AppUrl.ADMIN_URL + 'manual-lead-follow-ups/' + uniqueId;
  }

  static FACEBOOK_LEAD(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'facebook-lead/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'facebook-lead';
    }
  }

  static CAMPAIGN(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'campaign/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'campaign';
    }
  }

  static GOOGLE_CAMPAIGNS(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + '/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + '';
    }
  }

  static LINKEDIN_CAMPAIGNS(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'linkedin-campaigns/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'linkedin-campaigns';
    }
  }

  static FETCH_CAMPAIGN_LEADS(): string {
    return AppUrl.ADMIN_URL + 'campaign-leads';
  }

  static FETCH_LINKEDIN_CAMPAIGN_LEADS(): string {
    return AppUrl.ADMIN_URL + 'linkedin-campaign-leads';
  }

  static FETCH_GOOGLE_CAMPAIGN_LEADS(): string {
    return AppUrl.ADMIN_URL + 'google-campaign-leads';
  }

  static CAMPAIGN_ACCESS_TOKEN(): string {
    return AppUrl.ADMIN_URL + 'facebook-login-url';
  }

  static LINKEDIN_CAMPAIGN_ACCESS_TOKEN(): string {
    return AppUrl.ADMIN_URL + 'linkedin-login-url';
  }

  static GOOGLE_CAMPAIGN_ACCESS_TOKEN(): string {
    return AppUrl.ADMIN_URL + 'google-login-url';
  }

  static FACEBOOK_LEAD_COUNT(): string {
    return AppUrl.ADMIN_URL + 'facebook-lead-count';
  }

  static FACEBOOK_LEAD_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'facebook-lead-status/' + unique_id;
  }

  static FACEBOOK_LEAD_ASSIGN(): string {
    return AppUrl.ADMIN_URL + 'facebook-lead-assign';
  }

  static FACEBOOK_LEAD_FOLLOW_UP(uniqueId): string {
    return AppUrl.ADMIN_URL + 'facebook-lead-follow-ups/' + uniqueId;
  }

  static FACEBOOK_LEAD_DOWNLOAD_REPORT(): string {
    return AppUrl.ADMIN_URL + 'facebook-lead-download-report';
  }

  static MESSENGER_LEAD(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'messenger-lead/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'messenger-lead';
    }
  }

  static MESSENGER_LEAD_ASSIGN(): string {
    return AppUrl.ADMIN_URL + 'messenger-lead-assign';
  }

  static MESSENGER_LEAD_FOLLOW_UP(uniqueId): string {
    return AppUrl.ADMIN_URL + 'messenger-lead-follow-ups/' + uniqueId;
  }

  static MESSENGER_LEAD_DOWNLOAD_REPORT(): string {
    return AppUrl.ADMIN_URL + 'messenger-lead-download-report';
  }

  static MESSENGER_LEAD_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'messenger-lead-status/' + unique_id;
  }

  static MESSENGER_LEAD_COUNT(): string {
    return AppUrl.ADMIN_URL + 'messenger-lead-count';
  }

  static INSTAGRAM_LEAD(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'instagram-lead/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'instagram-lead';
    }
  }

  static INSTAGRAM_LEAD_ASSIGN(): string {
    return AppUrl.ADMIN_URL + 'instagram-lead-assign';
  }

  static INSTAGRAM_LEAD_FOLLOW_UP(uniqueId): string {
    return AppUrl.ADMIN_URL + 'instagram-lead-follow-ups/' + uniqueId;
  }

  static INSTAGRAM_LEAD_DOWNLOAD_REPORT(): string {
    return AppUrl.ADMIN_URL + 'instagram-lead-download-report';
  }

  static INSTAGRAM_LEAD_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'instagram-lead-status/' + unique_id;
  }

  static INSTAGRAM_LEAD_COUNT(): string {
    return AppUrl.ADMIN_URL + 'instagram-lead-count';
  }

  static INCOMING_CALLS(): string {
    return AppUrl.ADMIN_URL + 'incoming-call-recording';
  }

  static OUTGOING_CALLS(): string {
    return AppUrl.ADMIN_URL + 'outgoing-call-recording';
  }

  static UPLOAD_CALLS(): string {
    return AppUrl.ADMIN_URL + 'upload-call-recording';
  }

  static CALL(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'call/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'call';
    }
  }

  static CALL_CURRENT_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'call-current-status/' + uniqueId;
  }

  static CALL_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'call-status/' + uniqueId;
  }

  static CALL_COUNT(): string {
    return AppUrl.ADMIN_URL + 'call-count';
  }

  static SMS(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'sms/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'sms';
    }
  }

  static SMS_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'sms-status/' + uniqueId;
  }

  static SMS_COUNT(): string {
    return AppUrl.ADMIN_URL + 'sms-count';
  }

  static WHATSAPP(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'whatsapp/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'whatsapp';
    }
  }

  static WHATSAPP_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'whatsapp-status/' + uniqueId;
  }

  static WHATSAPP_COUNT(): string {
    return AppUrl.ADMIN_URL + 'whatsapp-count';
  }

  static CURRENT_DATE_TIME(): string {
    return AppUrl.ADMIN_URL + 'current-date-time';
  }

  static RECORDED_CALLS(): string {
    return AppUrl.ADMIN_URL + 'call-recording';
  }

  static AGENT_LIST(): string {
    return AppUrl.ADMIN_URL + 'agent-list';
  }

  static AUDIT_RECORDING(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'audit-call-recording/' + uniqueId;
  }

  static SUPPORT_TICKET(id?: any): string {
    if (id) return AppUrl.ADMIN_URL + 'support-ticket/' + id;
    else return AppUrl.ADMIN_URL + 'support-ticket';
  }

  static SUPPORT_TICKET_STATUS(id: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-status/' + id;
  }

  static SUPER_ADMIN_DASHBOARD(): string {
    return AppUrl.ADMIN_URL + 'dashboard';
  }

  static ASSIGNED_AGENTS_LIST(id: any): string {
    return AppUrl.ADMIN_URL + 'assigned-agent-list/' + id;
  }

  static ASSIGN_AGENTS(id: any): string {
    return AppUrl.ADMIN_URL + 'assign-agent/' + id;
  }

  static UPLOAD_MANUAL_LEAD_EXCEL(): string {
    return AppUrl.ADMIN_URL + 'manual-lead-import';
  }
}

